import groupby from "lodash.groupby";
import mapvalues from "lodash.mapvalues";
import { FETCH_HASHTAGS_SUCCESS } from "../actions";
import { defaultResultsByCount } from "./sampleResults";
export const defaultState = {
  // ...defaultResultsByCount
};

const resultsByCount = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_HASHTAGS_SUCCESS:
      const groupsByCount = groupby(action.items, "media_count");
      const idsByCount = mapvalues(groupsByCount, group =>
        group.map(result => result.name)
      );
      return idsByCount;
    default:
      return state;
  }
};

export default resultsByCount;



// WEBPACK FOOTER //
// ./src/reducers/resultsByCount.js